import React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import getGridHeight from "@src/utils/getGridHeight";

interface Props {
	className?: string;
	animateIn?: boolean;
}

const variants = {
	hidden: { y: 20, opacity: 0 },
	shown: {
		y: 0,
		opacity: 1,
		transition: { type: "spring", stiffness: 60, damping: 25, mass: 1.5 },
	},
};
const Float: React.FC<Props> = (props) => {
	const { className, animateIn } = props;
	return (
		<motion.div
			className={props.className}
			variants={variants}
			initial={animateIn ? "hidden" : "shown"}
			whileInView={animateIn ? "shown" : undefined}
			viewport={{ margin: "0px 0px -35%", once: true }}
		>
			{props.children}
		</motion.div>
	);
};

export default styled(Float)``;
